"use strict";

module.exports = function () {
    this.displayColumnsDropdown = !this.displayColumnsDropdown;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/toggle-columns-dropdown.js
// module id = 1503
// module chunks = 0